import React from "react";
import PageHero from "../components/PageHero";
import SectionHeader from "../components/SectionHeader";
import CTASection from "../components/CTASection";

const SECTIONS = [
  { t: "Education Institution Supplies", d: "School and college consumables, stationery, classroom equipment." },
  { t: "Hostel Supplies", d: "Beds, mattresses, linens, dining items, kitchen supplies, housekeeping." },
  { t: "Kitchen Supplies", d: "Utensils, cooking equipment, storage containers, dining items, appliances." },
  { t: "Office Supplies", d: "Furniture, stationery, IT peripherals, networking, electrical accessories." },
  { t: "FMCG & Grocery", d: "Grocery, packaged food, beverages, dairy products, daily essentials." },
  { t: "Furniture", d: "Classroom, hostel, office and dining furniture solutions." },
  { t: "Cleaning & Housekeeping", d: "Cleaning chemicals, tools, sanitation and hygiene supplies." },
  { t: "Requirement-Based Fulfilment", d: "Custom sourcing for departments, institutions and tenders." },
];

export default function Institutional() {
  return (
    <div>
      <PageHero
        kicker="Institutional Supplies"
        title="Schools, Hostels, Offices & Public Institutions"
        description="Multi-category supply for residential schools, hostels, government schools, offices and public bodies — with bulk supply and tender-support documentation."
        primary={{ to: "/submit", label: "Submit Supply Requirement" }}
        secondary={{ to: "/products", label: "All Categories" }}
        image="/img/institutional-supplies.png"
      />

      <section className="section">
        <div className="container-x">
          <SectionHeader kicker="What We Supply" title="Institutional Categories" />
          <div className="grid-cards mt-8">
            {SECTIONS.map((s) => (
              <div key={s.t} className="card-premium p-5">
                <div className="font-semibold text-navy text-base">{s.t}</div>
                <div className="divider-gold" />
                <p className="text-sm text-[var(--melopa-muted)]">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection title="Bulk supply for an institution or department?" description="Share your bill of quantities or tender document. We will revert with the right proposal." />
    </div>
  );
}
